import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid, Box, Modal,Backdrop, CircularProgress,LinearProgress, TextareaAutosize } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../../api/DnerhsApi";
import FormInput from "../../../Controls/Input";
import Alert from "../../../components/Alert";
import ResponseUtils from "../../../utils/ResponseUtils";
import history from "../../../utils/History";
import { useParams, useLocation } from "react-router-dom";
import useAuth from "../../../hooks/Auth";
import Tooltip from "@material-ui/core/Tooltip";
import { findById } from "../../../constants/Meses";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import Checkbox from '@material-ui/core/Checkbox';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from '@material-ui/icons/Clear';
import { trackPromise} from 'react-promise-tracker';
import Roles from "../../../constants/Roles";
import EstadosCronograma from "../../../constants/EstadosCronograma";
import ConfirmDialog from "dialogs/ConfirmDialog";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';


const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
  modal: {
    position:'absolute',
    width: 800,
    backgroundColor: 'white',
    borderRadius: 5,
    borderColor: 'white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2,4,2),
    //padding: "30px 80px 60px",
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    focus:{
      outline: 'none'
  },outline: 'none'
  },
}));

const Form = () => {
  const classes = useStyles();
  const [listPracticas, setListPracticas] = useState([]);
  const [listPracticasOriginal, setListPracticasOriginal] = useState([]);
  const [cedulaIdentidad, setCedulaIdentidad] = useState("");
  const params = useParams();
  const methods = useForm({});
  const { handleSubmi, setValue } = methods;
  const [{isReadOnly}, setIsReadOnly] = useState(false);
  const [solicitudFinalizada, setSolicitudFinalizada] = useState(false);
  const { hasRole, hasAnyRole } = useAuth();
  let { state } = useLocation();
  const [bandera, setBandera] = useState("");
  const [practicaResponseData, setPracticaResponseData] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [sent, setSent] = useState(false);
  const [observacion, setRechazoObservacion] = useState();
  const [modal, setModal]=useState(false);
  const [openGuardar, setOpenGuardar]=useState(false);

  
  const abrirCerrarModal =()=>{
    setModal(!modal);
  }
    const cerrarModal =()=>{  
    setModal(!modal);
    //confirmOne();   
  }
  const handleObservacionChange = ( value) => {
    //rechazoObservacion=value;
    setRechazoObservacion(value);
  };

  useEffect(() => {
    const load = () => {
      try {
        if (state?.edit || state?.readOnly) {
          setIsReadOnly(state.readOnly);
          getServerData();
        } 
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);
  
  const confirmOne = () => {
    handleCloseDialog();
    abrirCerrarModal();
    setSent(false);
    setOpenGuardar(true);
    confirmOnePost();
  }
  const confirmOnePost = async () => {

    try {
      if (observacion == "") {
        Alert.show({
          message : "Por favor ingrese una observación",
          type : "error"
        });
        return;
      }
      
      // Condicionar si la solicitud de plaza ya esté con estado "Finalizado"

      console.log('solicitudFinalizada dentro del botón finalizar', solicitudFinalizada);
      if(solicitudFinalizada == false){
        console.log('No está finalizada la solicitud, médotod normal');
        
        await trackPromise(DnerhsApi.post(
          `/convenios/practicas/${practicaResponseData.id}/finalizar-cronograma?observacion=${observacion}`
        ));
        
  
  
        setSent(true);
        Alert.show({
          message: "El Cronograma de Practicas ha Finalizado exitosamente.",
          type: "success",
        });
      } else {
        console.log('Ya está finalizada la solicitud, método nuevo');

        // Nuevo post
        await trackPromise(DnerhsApi.post(
          `/convenios/practicas/${practicaResponseData.id}/finalizar-cronograma-solicitud-finalizada?observacion=${observacion}`
        ));

        
        setSent(true);
        Alert.show({
          message: "El Cronograma de Practicas ha Finalizado exitosamente.",
          type: "success",
        });
      }
      

     
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
       } 
    }

    // history.goBack()

  };

//  <Box sx={classes.box}>
const bodyModal= (
    
  <div className={classes.modal} align="center" classes={{focused: classes.outlinedInputFocused}}>
    <Paper>
      <Card>
      <CardContent>
        <div>
        <br/>
        <Typography align="center" variant="h5" color="primary">
        Observaciones Finalizar Cronograma
            </Typography>
    
             <br/>

        </div>
        <br/> <br/>
        <Grid item className={classes.field}>
        <TextareaAutosize aria-label="Observacion"  rows={6} rowsMax={10}  placeholder="Observaciones" onChange={(e) =>
                                handleObservacionChange(e.target.value)}
                                style={{width: 600, fontSize: 0.875+'rem', fontFamily: 'Roboto', fontWeight: 400,
                                lineHeight: 1.43,
                                letterSpacing: 0.01071+'em', borderRadius: 10+'px'}}
                                />
        </Grid>
        <br/> <br/>
        <Grid container direction="row" justifyContent="flex-end" alignItems="center">
      
         
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="default"
              onClick={()=>cerrarModal()}>Cancelar
            </Button>
          </Grid>
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => confirmOne()}
              disabled={openGuardar} 
              >
             
              Guardar
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
    </Paper>
  </div>
  
)
  const getServerData = async () => {
    try {
      try {
        let { convenioPracticaId } = params;
  
        const { data: practicaResponseData } = await DnerhsApi.get(
          `/convenios/practicas/${convenioPracticaId}`
        );


        setPracticaResponseData(practicaResponseData);
        const { data: practicaDetalleResponseData } = await trackPromise(DnerhsApi.get(
          `/practicas-detalles/${convenioPracticaId}/practicas-detalles`
        ));

        practicaResponseData.practicaDetalleList=practicaDetalleResponseData;

        console.log('practicaDetalleResponseData:', practicaDetalleResponseData[0].solicitudPlaza.estado == "Utilizado");

        console.log('solicitudFinalizada', solicitudFinalizada);
        // 
        if (practicaDetalleResponseData[0].solicitudPlaza.estado == "Finalizado"){
          // No tocar valores de plazas
          console.log('Cronograma finalizado');
          setSolicitudFinalizada(true);
        } else {
          // Actuar normalmente
          console.log('Cronograma no finalizado');

        }

        console.log('solicitudFinalizada después', solicitudFinalizada);
         const formValues = {
          carrera: practicaResponseData.convenioCarrera?.carreraPrograma?.descripcion==="Postgrado"? "Postgrado - " + practicaResponseData.convenioCarrera?.nombrePostgrado?.descripcion : practicaResponseData.convenioCarrera?.carreraPrograma?.descripcion,
          materia: practicaResponseData.materia,
          curso: practicaResponseData.curso,
          semestre: practicaResponseData.semestre,
          observacion: practicaResponseData.observacion,
        };
  
        Object.keys(formValues).forEach((field) => {
          setValue(field, formValues[field]);
        });
        /*practicaResponseData.practicaDetalleList.forEach( async (k) => {
          const { data: practicaDetalleHorarioIdResponseData } = await trackPromise(DnerhsApi.get(
            `/practicas-detalles-horarios/${k.id}/horarios`
          ));
          
          k.practicaDetalleHorarioList=practicaDetalleHorarioIdResponseData;
          if(k.practicaDetalleHorarioList){
            k.practicaDetalleHorarioList.forEach((ho)=>{
              console.log(ho);
              if(ho.dia=="1"){ 
                k.lunes=true;
              }
              if(ho.dia=="2"){ 
                k.martes=true;
              }
              if(ho.dia=="3"){ 
                k.miercoles=true;
              }
              if(ho.dia=="4"){ 
                k.jueves=true;
              }
              if(ho.dia=="5"){ 
                k.viernes=true;
              }
              if(ho.dia=="6"){ 
                k.sabado=true;
              }
              if(ho.dia=="7"){ 
                k.domingo=true;
              }
            });
            
          }*/
          /*contadorHorarios++;
          if( practicaResponseData.practicaDetalleList.length===contadorHorarios){
            setListPracticas(practicaResponseData.practicaDetalleList);
            let carreraAux=getValues("carrera");
            let [responseCarreras] = await Promise.all([ getCarrerasProgramas(params.convenioId)] )
            responseCarreras.data.forEach((el)=>{
              if(el.id===carreraAux){
                setCarrAux(el.carreraPrograma.id);
              }
            });
          }*/
        //});*/
        /*let { practicaDetalleList } = practicaResponseData;
        
        setListPracticas(practicaDetalleList);
        setListPracticasOriginal(practicaDetalleList);*/
        let contadorHorarios=0;
      practicaResponseData.practicaDetalleList.forEach( async (k) => {
        const { data: practicaDetalleHorarioIdResponseData } = await trackPromise(DnerhsApi.get(
          `/practicas-detalles-horarios/${k.id}/horarios`
        ));
        
        k.practicaDetalleHorarioList=practicaDetalleHorarioIdResponseData;
        if(k.practicaDetalleHorarioList){
          k.practicaDetalleHorarioList.forEach((ho)=>{
            console.log(ho);
            if(ho.dia=="1"){ 
              k.lunes=true;
            }
            if(ho.dia=="2"){ 
              k.martes=true;
            }
            if(ho.dia=="3"){ 
              k.miercoles=true;
            }
            if(ho.dia=="4"){ 
              k.jueves=true;
            }
            if(ho.dia=="5"){ 
              k.viernes=true;
            }
            if(ho.dia=="6"){ 
              k.sabado=true;
            }
            if(ho.dia=="7"){ 
              k.domingo=true;
            }
            k.horarioDesde = ho.horarioDesde
            k.horarioHasta = ho.horarioHasta
          });
          
        }
        contadorHorarios++;
        if( practicaResponseData.practicaDetalleList.length===contadorHorarios){
          setListPracticas(practicaResponseData.practicaDetalleList);
          //let carreraAux=getValues("carrera");
          /*let [responseCarreras] = await Promise.all([ getCarrerasProgramas(params.convenioId)] )
          responseCarreras.data.forEach((el)=>{
            if(el.id===carreraAux){
              setCarrAux(el.carreraPrograma.id);
            }
          });*/
        }
      });
      } catch (error) {
        console.log(error);
        if (error.response) {
          showServerError(error);
        } else {
          showMessageError(error);
        }
      }

    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  };

  const handleSearchEstudiante = () => {
    if (cedulaIdentidad) {
      let listPracticaFilter = listPracticasOriginal.filter(
        item => item.convenioEstudiante.estudiante.cedulaIdentidad == cedulaIdentidad
      );
      setListPracticas(listPracticaFilter);
    }else {
      setListPracticas(listPracticasOriginal);
    }
  }

  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error",
    });
  };

  const showMessageError = (message) => {
    Alert.show({
      message,
      type: "error",
    });
  };

  const handleChangeConfirmacion = async (event, row) => {
    try {

      const result= await trackPromise( DnerhsApi.post(
        `/convenios/practicas/confirmacion/${row.id}?confirmacion=${event.target.checked}`
      ));
      if(row.confirmacion){     
        Alert.show({
          message: "Practica no confirmada exitosamente.",
          type: "success",
        });
      }else{
        Alert.show({
          message: "Practica  confirmada exitosamente.",
          type: "success",
        });
      }

      trackPromise(getServerData());
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  }

  const checkDayFormat = (day) => {
    return day ? (
      <CheckIcon color="secondary" />
    ) : (
      <CloseIcon color="primary" />
    );
  }

  const handleNumeroDocumentoKeyPress = (event) => {
    if(event.key === 'Enter'){
     handleSearchEstudiante();
    }
  }

  const handleResetSearch = () => {
    setCedulaIdentidad("");
    setListPracticas(listPracticasOriginal);
  }

  const handleChangeCedulaIdentidad = (event) => {
    setCedulaIdentidad(event.target.value)
  }
  const showButtonFinalizar = practicaResponseData.id &&
  (
    practicaResponseData.estado === EstadosCronograma.PRACTICA_APROBADA ||
    practicaResponseData.estado === EstadosCronograma.PRACTICA_MODIFICACIONES_APROBADA);

  const isCronogramaFinalizado =
    practicaResponseData.estado === EstadosCronograma.PRACTICA_CRONOGRAMA_FINALIZADA;
  const isCronogramaConfirmable =
    practicaResponseData.estado === EstadosCronograma.PRACTICA_APROBADA ||
    practicaResponseData.estado === EstadosCronograma.PRACTICA_MODIFICACIONES_APROBADA ||
    isCronogramaFinalizado;
  const pendientesInstitucion = listPracticas.filter((row) => row.confirmacion !== true).length;
  const pendientesEstablecimiento = listPracticas.filter((row) => row.confirmacionEstablecimiento !== true).length;
  const mensajeEstadoConfirmaciones = () => {
    if (!listPracticas.length) {
      return "";
    }
    const total = listPracticas.length;
    return `Confirmaciones de asistencia: Institucion Formadora ${total - pendientesInstitucion}/${total}, Servicio/Establecimiento ${total - pendientesEstablecimiento}/${total}. Los pendientes pueden corresponder a alumnos que no asistieron.`;
  };
  const puedeEditarConfirmacionInstitucion = (row) => {
    if (!isCronogramaConfirmable) {
      return false;
    }
    return true;
  };
  const tooltipConfirmacionInstitucion = (row) => {
    if (isCronogramaFinalizado) {
      return "Confirmar o desconfirmar asistencia del alumno.";
    }
    return "Confirmar Institucion Formadora";
  };
  /*MODAL*/
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };



  return (
    <>
      <Paper>
        <Box padding={5}>
          <Grid item xs={12}>
            <Typography align="center" variant="h5" color="primary">
              Confirmación de Prácticas
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormProvider {...methods}>
              <form>
                <Grid container direction="row">
                  <Grid item xs={6}>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        name="carrera"
                        label="Carrera"
                        disabled={{isReadOnly}}
                      />
                    </Grid>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        name="materia"
                        label="Materia"
                        disabled={{isReadOnly}}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        type="number"
                        name="curso"
                        label="Curso"
                        disabled={{isReadOnly}}
                      />
                    </Grid>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        type="number"
                        name="semestre"
                        label="Semestre"
                        disabled={{isReadOnly}} 
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </FormProvider>
          </Grid>
          <Grid item xs={12}>
            <Typography align="center" variant="h6" color="primary">
              Estudiantes
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            className={classes.field}
          >
            <TextField
              fullWidth
              value={cedulaIdentidad}
              defaulValue=""
              onChange={handleChangeCedulaIdentidad}
              onKeyPress={handleNumeroDocumentoKeyPress}
              label="Cédula de identidad"
              InputProps={{
                endAdornment: (
                  <>
                  <InputAdornment position="end" onClick={handleResetSearch}>
                  <IconButton>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
                  <InputAdornment position="end" onClick={handleSearchEstudiante}>
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                  </>
                ),
              }}
            />
          </Grid>
          {listPracticas.length > 0 && (
            <Grid item xs={12} className={classes.field}>
              <Typography
                variant="body2"
                color={pendientesInstitucion === 0 && pendientesEstablecimiento === 0 ? "primary" : "error"}
              >
                {mensajeEstadoConfirmaciones()}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Grid item xs={12}>
              <TableContainer>
                <Table aria-label="Datos estadisticos">
                  <TableHead>
                    <TableRow>
                    <TableCell align="left">C.I.</TableCell>
                      <TableCell align="left">Año</TableCell>
                      <TableCell align="left">Alumno</TableCell>
                      <TableCell align="left">Nacionalidad</TableCell>
                      <TableCell align="left">Sede</TableCell>                   
                      <TableCell align="left">D</TableCell>
                      <TableCell align="left">L</TableCell>
                      <TableCell align="left">M</TableCell>
                      <TableCell align="left">X</TableCell>
                      <TableCell align="left">J</TableCell>
                      <TableCell align="left">V</TableCell>
                      <TableCell align="left">S</TableCell>
                      <TableCell align="left">Horario Desde/Hasta</TableCell>
                      <TableCell align="left">Total Horas</TableCell>
                      <TableCell align="left">C.I. Tutor</TableCell>

                      <TableCell align="left">Tutor</TableCell>
                      <TableCell align="left">Horario del Tutor</TableCell>
                      <TableCell align="left">Establecimiento</TableCell>
                      <TableCell align="left">Confirmado</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {listPracticas.length > 0 ? (
                      listPracticas.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell align="left">
                            {row.convenioEstudiante?.estudiante.cedulaIdentidad}
                          </TableCell>
                          <TableCell align="left">{row.anio}</TableCell>
                          <TableCell align="left">
                            {row.convenioEstudiante?.estudiante.nombres}&nbsp;{row.convenioEstudiante?.estudiante.apellidos}
                          </TableCell>
                          <TableCell align="left">
                            {row.convenioEstudiante?.estudiante.nacionalidad.nombre}
                          </TableCell>
                          <TableCell align="left">
                            {row.convenioEstudiante?.convenio.institucionFormadora.sede}
                          </TableCell>
                          <TableCell align="left">
                            {checkDayFormat(row.domingo)}
                          </TableCell>
                          <TableCell align="left">
                            {checkDayFormat(row.lunes)}
                          </TableCell>
                          <TableCell align="left">
                            {checkDayFormat(row.martes)}
                          </TableCell>
                          <TableCell align="left">
                            {checkDayFormat(row.miercoles)}
                          </TableCell>
                          <TableCell align="left">
                            {checkDayFormat(row.jueves)}
                          </TableCell>
                          <TableCell align="left">
                            {checkDayFormat(row.viernes)}
                          </TableCell>
                          <TableCell align="left">
                            {checkDayFormat(row.sabado)}
                          </TableCell>                          

                          <TableCell align="left">
                            {row.horarioDesde + " - " + row.horarioHasta}
                          </TableCell>

                          <TableCell align="left">
                            {row.totalHoras + " hs"}
                          </TableCell>
                          <TableCell align="left">
                          {row.convenioTutor?.tutor?.cedulaIdentidad}
                          </TableCell>
                          <TableCell align="left">
                            {row.convenioTutor?.tutor?.nombres}&nbsp;{ row.convenioTutor?.tutor?.apellidos}
                          </TableCell>
                          <TableCell align="left">
                            {row.horarioDesde + " - " + row.horarioHasta}
                          </TableCell>
                          <TableCell align="left">
                            {row.establecimiento?.nombreServicio.nombre}
                          </TableCell>
                          <TableCell align="left">
                            <Tooltip title={tooltipConfirmacionInstitucion(row)} aria-label="confirmar">
                              <Checkbox
                                checked={Boolean(row.confirmacion)}
                                onChange={(event) =>
                                  handleChangeConfirmacion(event, row)
                                }
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                                disabled={!puedeEditarConfirmacionInstitucion(row)}
                              />
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={15}>
                          <Typography
                            align="center"
                            color="primary"
                            variant="body1"
                          >
                            No hay datos para mostrar
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>

         


          <Grid item xs={12}>
            <Box paddingTop={3}>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item className={classes.field}>
                  <Button
                    variant="contained"
                    color="default"
                    onClick={() => history.goBack()}
                  >
                    Atrás
                  </Button>
                </Grid>
                {hasRole(Roles.ROLE_USER) && (
                  <>
                  

                    {showButtonFinalizar && (
                      <Grid item className={classes.field}>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => abrirCerrarModal()}
                        >
                          Finalizar Cronograma
                        </Button>
                      </Grid>
                    )}
                   
                  </>
                )}
              </Grid>
            </Box>
          </Grid>
        </Box>
        <ConfirmDialog
            open={openDialog}            
            onAccept={confirmOne}
            onSave={confirmOne}
            onClose={handleCloseDialog}
            aria-labelledby="form-dialog-title"
          />
      </Paper>
      <Modal backdrop="static"
        open={modal} variant="standard"
        InputProps={{
                disableUnderline: true,
              }}
              style={{outline: 'none'}}
              classes={{focused: classes.outlinedInputFocused}}
      >
      
        {bodyModal}
      </Modal>
    </>
  );
};

export default Form;
